import { handleSendWebsocketEpic } from './epics/sendWebsocketEpic';

export const WebsocketEpics = [handleSendWebsocketEpic];
